<template>
  <div>
    <b-menu-list :label="currentConfigLevel['heading']">
      <b-menu-item
          v-for="(item, i1) of items"
          @click="activated(currentPath(item))"
          :active="isActiveCheck(item)"
          :expanded="isExpandedCheck(item)"
          :key="i1"
      >
        <template #label="props">
          <GenexDisableableTooltip
              :label="item[currentConfigLevel['labelField']] "
              position="is-right"
              :disabled="!currentConfigLevel['hasTooltip']"
          >
            <template v-if="currentConfigLevel['icon']['isDynamic']">
              <b-icon
                  :icon="props.expanded ? item[currentConfigLevel['icon']['openField']] : item[currentConfigLevel['icon']['closedField']]"
                  class="has-text-black is-pulled-left mr-1"
              >
              </b-icon>
            </template>
            <template v-else>
              <b-icon
                  :icon="props.expanded ? currentConfigLevel['icon']['open'] : currentConfigLevel['icon']['closed']"
                  class="has-text-black is-pulled-left mr-1"
              >
              </b-icon>
            </template>
            <template v-if="item[currentConfigLevel['labelField']].length">
              <span>{{ item[currentConfigLevel['labelField']] }}</span>
            </template>
            <template v-else>
              <span>&nbsp;</span>
            </template>

          </GenexDisableableTooltip>
        </template>
        <template v-if="subItems(i1).length !== 0">

          <MenuRecursiveHelper
              :items="subItems(i1)"
              :prevPath="currentPath(item)"
              @input="activated"
              :value="String(value)"
              :allLevelsConfig="allLevelsConfig"
              :currentNestingDepth="currentNestingDepth+1"
          />
        </template>
      </b-menu-item>
    </b-menu-list>
  </div>
</template>

<script>
import GenexDisableableTooltip from "@/components/global/GenexDisableableTooltip.vue";

export default {
  name: "MenuRecursiveHelper",
  components: {
    GenexDisableableTooltip
  },
  data() {
    return {
    };
  },
  props: {
    items: {
      type: Array,
      default() {
        return []
      }
    },
    nameOfChild: {
      type: String,
      default: ""
    },
    prevPath: {
      type: String,
      default() {
        return ""
      }
    },
    value: {
      type: String,
      default() {
        return ""
      }
    },
    allLevelsConfig: {
      type: Array,
      default() {
        return []
      }
    },
    currentNestingDepth: {
      type: Number,
      default() {
        return null
      }
    },
  },
  computed:{
    currentConfigLevel(){
      if(typeof this.allLevelsConfig[this.currentNestingDepth] !== 'undefined') {
        const result = this.allLevelsConfig[this.currentNestingDepth]
        return result
      }
      return {}
    },
    nextConfigLevel(){
      if(typeof this.allLevelsConfig[this.currentNestingDepth+1] !== 'undefined') {
        const result = this.allLevelsConfig[this.currentNestingDepth+1]
        return result
      }
      return {}
    },
  },
  methods:{
    activated(path){
      this.$emit("input", path)
    },
    subItems(index){
      if (Object.prototype.hasOwnProperty.call(this.items[index], this.nextConfigLevel["type"])){
        return this.items[index][this.nextConfigLevel["type"]]
      }
      return []
    },
    currentPath(item){
      if (this.currentNestingDepth == 0){
        return String(item[this.currentConfigLevel['idField']])
      } else {
        return this.prevPath+'-'+item[this.currentConfigLevel['idField']]
      }
    },
    isActiveCheck(item){
      const check = this.value == this.currentPath(item)
      if (check){
        return true
      } else {
        return false
      }
    },
    isExpandedCheck(item){
      return this.startsWithForArrays(
          this.value.split('-'),
          this.currentPath(item).split('-')
      )
    },
    startsWithForArrays(thing, startsWithMe){
      for (const key in startsWithMe) {
        if (thing[key] !== startsWithMe[key]){
          return false
        }
      }
      return true
    }
  }
};
</script>
